import React from 'react';
import {Form, Input, Select, Col, Row,  message } from 'antd';
import ModalDom from '../../../../components/Modal';
import { CustomRow, CustomCol } from '../../../../components/Custom';
import { post, config, postFrom } from '../../../../axios';
import {
    dicExecutionCycle
} from '../../../../axios/dictionaries';
import {
    API_Merchant_findWftPayChannelConfigAll, API_wftPayChannel_copyWftPayChannelConfigClrgRule,
} from "../../../../axios/config";
import {formatTime} from "../../../../utils";

const Option = Select.Option;

class Page extends React.Component {
    constructor() {
        super();
        this.state = {
            loading: false,
            title: "拷贝分账规则",
            radioLessReliefTypeValue:false,
            wftPayChannelList:[],//惠市宝支付渠道
            merchantData: [],
            selectUpperLimitValue: false,
            data: {
            },
        }
    }






    render() {
        let { visible, form: { getFieldDecorator, setFieldsValue } } = this.props;
        let {
            loading,
            title,
            data,
        } = this.state;

        return <ModalDom
            title={title}
            visible={visible}
            loading={loading}
            onOk={this.handleOk}
            onCancel={this.handleCancel}
        >
            <div className="custom">
                <Form
                    labelCol={{ span: 0 }}
                    wrapperCol={{ span: 24 }}
                >
                    {getFieldDecorator('id', {
                        initialValue: data.id
                    })(
                        <Input type={'hidden'} />
                    )}
                    <Row>
                        <Col span={24}>
                            <CustomRow>
                                <CustomCol label="支付渠道">
                                    {getFieldDecorator('wftPayChannelConfigId', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.wftPayChannelConfigId
                                    })(
                                        <Select   placeholder="请选择支付渠道"  showSearch  optionFilterProp={'children'}>
                                            {this.state.wftPayChannelList.map(e => (
                                                <Select.Option key={e.id} value={e.id}>{e.projectName}</Select.Option>
                                            ))}
                                        </Select>
                                    )}
                                </CustomCol>
                            </CustomRow>
                            <CustomRow divider>
                                <CustomCol label="复制执行周期">
                                    {getFieldDecorator('executionCycle', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.executionCycle
                                    })(
                                        <Select
                                            showSearch
                                            placeholder="请选择执行周期"
                                            optionFilterProp={'children'}
                                        >
                                            {dicExecutionCycle.map((item, index) => <Option value={item.value} key={item.value}>{item.title}</Option>)}
                                        </Select>
                                    )}
                                </CustomCol>

                            </CustomRow>
                            <CustomRow divider>
                                <CustomCol label="目标执行周期">
                                    {getFieldDecorator('newExecutionCycle', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.newExecutionCycle
                                    })(
                                        <Select
                                            showSearch
                                            placeholder="请选择执行周期"
                                            optionFilterProp={'children'}
                                        >
                                            {dicExecutionCycle.map((item, index) => <Option value={item.value} key={item.value}>{item.title}</Option>)}
                                        </Select>
                                    )}
                                </CustomCol>
                            </CustomRow>
                        </Col>
                    </Row>
                </Form>
            </div>
        </ModalDom>
    }

    componentDidMount() {
        this.props.onRef(this);
    }


    handleCancel = () => { //关闭页面
        this.props.handleCancel();

        this.setState({ data: {}, loading: false, title: "拷贝分账规则",wftPayChannelList: [], selectUpperLimitValue:false });
    }

    initPack = () => {
        this.forceUpdate();
        this.postHsbPayChannelConfigAll();
    }



    postHsbPayChannelConfigAll =() =>{
        post({ url: API_Merchant_findWftPayChannelConfigAll }).then(res => {
            this.setState({ wftPayChannelList: res })
        })
    }


    handleOk = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
            if (!error) {
                this.setState({ loading: true });

                post({ url: config.API_wftPayChannel_copyWftPayChannelConfigClrgRule, data: values }).then(res => {
                    message.success('复制成功');
                    this.props.handleGetList();
                    this.handleCancel();
                }).catch(err => {
                    message.error(err.message || '复制失败');
                    this.setState({ loading: false });
                })
            }
        })
    }
}

export default Form.create()(Page);


// WEBPACK FOOTER //
// ./src/page/WftPayClrgRule/components/ListCopy/index.js